<script setup lang="ts">
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { computed } from "vue";

definePage({
  meta: {
    title: "Cooperation Case Room",
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.PRACTICE__PRACTICE);
    },
  },
});

const { t } = useI18n();
const route = useRoute();
const roomId = computed(() => (route.params as { id: string }).id);
</script>

<template>
  <div class="tw:flex tw:flex-col tw:h-full">
    <v-card
      rounded="lg"
      class="tw:!mb-5 tw:!py-4 tw:!rounded-tl-none"
    >
      <v-card-text>
        <div class="tw:!font-bold tw:text-on-surface tw:text-2xl">
          {{ t("models.referral.caseRoom.pageTitle") }}
        </div>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-card
          rounded="lg"
          class="tw:h-full tw:!p-0"
        >
          <v-card-text class="tw:!p-0"> </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <v-card
          rounded="lg"
          class="tw:h-full tw:!p-5"
        >
          <v-card-text class="tw:flex tw:flex-col tw:justify-center tw:items-center tw:h-full">
            <v-card
              class="tw:w-full"
              variant="outlined"
              color="blue-grey-lighten-4"
            >
              <v-card-text class="tw:!text-primary">
                <div class="tw:font-bold tw:mb-4">
                  {{ t("models.referral.caseRoom.summary.title") }}
                </div>
                <div class="tw:text-on-surface/60 tw:!mb-2">
                  Photos only • Free Referral • {{ roomId }}
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <div class="tw:flex tw:justify-between">
                      <span>Patient:</span>
                      <span class="tw:text-on-surface/60"> D.H. (DOB 2009) </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Priority:</span>
                      <span class="tw:text-on-surface/60"> Routine </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Reason for referral:</span>
                      <span class="tw:text-on-surface/60"> Crowding, Class II div 1 </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Requested service:</span>
                      <span class="tw:text-on-surface/60"> L2 • With records ⓘ </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Fee & payer:</span>
                      <span class="tw:text-on-surface/60"> Free! (Ortho) </span>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <div class="tw:flex tw:justify-between">
                      <span>Target start:</span>
                      <span class="tw:text-on-surface/60"> Week of Nov 6 (flexible) </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Clinic location:</span>
                      <span class="tw:text-on-surface/60"> Downtown practice </span>
                    </div>
                    <div class="tw:flex tw:justify-between">
                      <span>Preferred days:</span>
                      <span class="tw:text-on-surface/60"> Tue/Thu </span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
